export enum ProductType
{
    All = 0,
    Refurbished = 1,
    New = 2,
    Used = 3
    
}